
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/datenschutz",
      function () {
        return require("private-next-pages/[locale]/datenschutz.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/datenschutz"])
      });
    }
  